export enum EFamilyRelations {
  SPOUSE = 'spouse',
  CHILD = 'child'
}
